// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__2iRcH","nav":"dashboard_nav__rdfvD"};